export default __webpack_public_path__ + "assets/images/ae39a8de78ac2b0b315bacdc67d53691.png";